<script setup lang="ts">
import FormPlans from "components/MyAccount/FormPlans.vue";
import FormCheckout from "components/MyAccount/FormCheckout.vue";
import HistoryOrders from "components/MyAccount/HistoryOrders.vue";
import FormUser from "components/MyAccount/FormUser.vue";
import FormCancel from "components/MyAccount/FormCancel.vue";
import ModalMessages from "components/Modais/ModalMessages.vue";
import router from "../../router";
</script>
<template>
  <div class="navbar-header-model mt-3">
    <div class="tab-scroll">
      <tabs
        v-model="selectedTab"
        :options="{
          useUrlFragment: true,
          disableScrollBehavior: true,
          defaultTabHash: 'model-tabs-individual',
        }"
      >
        <tab
          v-for="(tab, i) in translate.navBar"
          :key="`t${i}`"
          :val="i"
          :label="tab"
          :indicator="true"
          @click="i === 1 ? redirect('MyCreditsPage') : ''"
        />
      </tabs>
    </div>
    <tab-panels v-model="selectedTab" :animate="true" :swipeable="false">
      <tab-panel :key="`tp0`" :val="0">
        <div class="row mb-5">
          <div v-if="order" class="alert alert-success col-12 mt-2" role="alert">
            <span class="px-2">
              {{ translate.alertMessageOrderActived }} <strong>{{ order.finish }}</strong>
            </span>
          </div>
          <div class="col-lg-6">
            <FormPlans :plans="plans" v-if="plans.length > 0" />
          </div>
          <div class="col-lg-6">
            <FormCheckout
              @showModalMessages="showModalMessages"
              @boleto="showPdfBoleto"
            />
            <PdfComponent v-if="urlPdf" :url="urlPdf" />
          </div>
        </div>
      </tab-panel>
      <tab-panel :key="`tp1`" :val="1"> </tab-panel>
      <tab-panel :key="`tp2`" :val="2">
        <FormCancel :dateCancel="order" />
      </tab-panel>
      <tab-panel :key="`tp3`" :val="3">
        <HistoryOrders />
      </tab-panel>
      <tab-panel :key="`tp4`" :val="4">
        <FormUser :user="user" @showModalMessages="showModalMessages" />
      </tab-panel>
      
    </tab-panels>
    <ModalMessages :options="optionsModal" @showModalMessages="showModalMessages" />
  </div>
</template>

<script lang="ts">
import { isMobile } from "views/shared/utils/mobile";
import { defineComponent } from "vue";
import { mapState, mapActions } from "pinia";
import { localeStore } from "stores/locale";
import { planStore } from "stores/plans";
import translateModel from "tradutors/myaccount";
import { Tabs, Tab, TabPanels, TabPanel } from "vue3-tabs";
import PdfComponent from "components/PdfComponent.vue";
import api from "../../api";
export default defineComponent({
  name: "NavBarHeader",
  props: ["user"],
  components: {
    Tabs,
    Tab,
    TabPanels,
    TabPanel,
  },
  computed: {
    ...mapState(localeStore, ["locale"]),
    ...mapState(planStore, ["plans", "languagePlans"]),
    translate: function () {
      if (this.locale === "pt-br") {
        return translateModel.portugues;
      } else {
        return translateModel.ingles;
      }
    },
  },
  watch: {
    locale: function () {
      this.getPlans();
      this.getOrderActiveUser();
    },
  },
  created() {
    this.tabs = this.translate.navBar;
    if (this.locale !== this.languagePlans) this.getPlans();
    this.getOrderActiveUser();
  },
  data() {
    return {
      selectedTab: 0,
      isMobile: isMobile(),
      tabs: [],
      dataModel: null,
      order: false,
      urlPdf: "",
      optionsModal: {
        showModal: false,
        titleModal: "Erro",
        textBodyModal: "",
        textButtonModal: "",
      },
    };
  },
  methods: {
    ...mapActions(planStore, ["setPlans"]),
    getOrderActiveUser() {
      api
        .get(`auth/isOrderActiveUser?locale=${this.locale ?? ""}`)
        .then(({ data: { orderActive } }) => {
          this.order = orderActive;
        });
    },
    tabChanged(val) {
      //console.log(val)
    },
    getPlans() {
      api
        .get(`v1/home/getPlansFreeTour?language=${this.locale ?? ""}`)
        .then(({ data }) => {
          this.setPlans(data.plansFreeTour);
        });
    },
    redirect(name) {
      router.push({ name, params: { locale: this.locale } });
    },
    showModalMessages({ message }) {
      this.optionsModal.showModal = message.show;
      this.optionsModal.titleModal = message.title;
      this.optionsModal.textBodyModal = message.textBoby;
      this.optionsModal.textButtonModal = message.textButton;
    },
    showPdfBoleto(value: string) {
      this.urlPdf = value;
    },
  },
});
</script>

<style scoped lang="css">
.tabs {
  cursor: pointer;
  display: flex;
  flex-wrap: nowrap !important;
}

.navbar-header-model >>> .tab {
  font-family: "Roboto-Medium";
  line-height: 16px;
  font-size: 14px !important;
}

.navbar-header-model .tabs > .active {
  color: #b20000;
  border-color: #b20000;
}

.tabs >>> .tab {
  padding: 10px 30px;
}

/* regras mobile 769vp */
@media screen and (max-width: 769px) {
  .tabs >>> .tab {
    padding: 10px 16px;
  }

  .navbar-header-model >>> .tab {
    font-size: 14px !important;
  }
}

/* regras mobile 800vp */
@media screen and (max-width: 800px) {
  .tab-scroll {
    position: relative;
    overflow: auto;
  }

  .tabs {
    width: 800px;
  }
}
</style>
